module.exports = __webpack_public_path__ + "static/media/empty_sent.3880678d.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/empty_sent.png
// module id = 786
// module chunks = 0